module.exports = __webpack_public_path__ + "img/silversands.0ea2bcff.png";